// Mock data for Becone Elevators Website

export const companyInfo = {
  name: "Becone Elevators",
  tagline: "Experts in Customized Design",
  yearsOfExperience: 30,
  certification: "IS 17900:2022",
  gstNumber: "32BGHPS0897P1ZM",
  email: "beconeelevators@gmail.com",
  phones: ["8113934720", "9388877078", "9846363902"],
  address: {
    line1: "IV/91, Sathya Bhavan",
    line2: "Cheriyapallam Thuruth, North Paravoor",
    district: "Ernakulam District",
    state: "Kerala - 683513",
    full: "IV/91, Sathya Bhavan, Cheriyapallam Thuruth, North Paravoor, Ernakulam District, Kerala - 683513"
  }
};

export const trustBadges = [
  {
    id: 1,
    icon: "Shield",
    title: "IS 17900:2022 Compliant",
    description: "Safety standards certified"
  },
  {
    id: 2,
    icon: "Award",
    title: "30+ Years Experience",
    description: "Industry expertise"
  },
  {
    id: 3,
    icon: "Wrench",
    title: "Customized Design",
    description: "Tailored solutions"
  },
  {
    id: 4,
    icon: "Clock",
    title: "1 Year Warranty",
    description: "Complete peace of mind"
  }
];

export const products = [
  {
    id: 1,
    name: "Passenger Elevators",
    description: "Premium passenger lifts for commercial and residential buildings with advanced safety features.",
    image: "https://images.unsplash.com/photo-1735178181188-855a87e83dca?w=600",
    features: ["VVVF Controller", "Automatic Doors", "LED Lighting", "SS Cabin Finish"],
    capacity: "4-20 Passengers",
    speed: "0.7-1.5 m/sec"
  },
  {
    id: 2,
    name: "Home Lifts",
    description: "Compact and elegant home lifts designed to enhance mobility and add value to your residence.",
    image: "https://images.unsplash.com/photo-1673006456789-ab4ab22edd88?w=600",
    features: ["Compact Design", "Low Noise", "Energy Efficient", "Premium Finishes"],
    capacity: "2-6 Passengers",
    speed: "0.4-0.7 m/sec"
  },
  {
    id: 3,
    name: "Gearless MRL Lifts",
    description: "Machine Room-Less elevators with gearless technology for smooth and efficient operation.",
    image: "https://images.unsplash.com/photo-1603788570887-405355e70ca6?w=600",
    features: ["No Machine Room", "Space Saving", "Energy Efficient", "Low Maintenance"],
    capacity: "8-26 Passengers",
    speed: "1.0-2.5 m/sec"
  },
  {
    id: 4,
    name: "Geared Elevators",
    description: "Reliable geared traction elevators with robust performance and excellent durability.",
    image: "https://images.unsplash.com/photo-1525273177952-67455d25871f?w=600",
    features: ["Robust Design", "High Reliability", "Cost Effective", "Easy Maintenance"],
    capacity: "6-13 Passengers",
    speed: "0.5-1.0 m/sec"
  },
  {
    id: 5,
    name: "Car Lifts",
    description: "Heavy-duty hydraulic and traction car lifts for basements and multi-level parking.",
    image: "https://images.pexels.com/photos/7002942/pexels-photo-7002942.jpeg?w=600",
    features: ["Hydraulic/Traction", "Heavy Duty", "Large Platform", "Safety Sensors"],
    capacity: "Up to 5000 Kg",
    speed: "0.2-0.4 m/sec"
  },
  {
    id: 6,
    name: "Goods Lifts",
    description: "Industrial goods elevators designed for heavy loads and frequent use in commercial settings.",
    image: "https://images.pexels.com/photos/5371696/pexels-photo-5371696.jpeg?w=600",
    features: ["Heavy Load Capacity", "Durable Construction", "Wide Doors", "Industrial Grade"],
    capacity: "500-3000 Kg",
    speed: "0.3-0.5 m/sec"
  }
];

export const safetyFeatures = [
  {
    id: 1,
    icon: "Gauge",
    title: "VVVF Drives",
    description: "Variable Voltage Variable Frequency drives for smooth acceleration and energy efficiency."
  },
  {
    id: 2,
    icon: "CircuitBoard",
    title: "Gearless Machines",
    description: "Advanced gearless traction machines for quiet and efficient operation."
  },
  {
    id: 3,
    icon: "DoorOpen",
    title: "Imported Door Operators",
    description: "Premium door operators from Wittur and Synergy for reliable performance."
  },
  {
    id: 4,
    icon: "ShieldAlert",
    title: "Advanced Safety Solution",
    description: "Innovative design allows elevator operation even if ARD fails. Never get stuck!"
  },
  {
    id: 5,
    icon: "Activity",
    title: "Speed Governor",
    description: "Precision speed governors to prevent overspeeding and ensure passenger safety."
  },
  {
    id: 6,
    icon: "Scan",
    title: "Door Sensors",
    description: "Infrared sensors prevent door closure accidents and ensure safe entry/exit."
  }
];

export const customizationOptions = [
  {
    id: 1,
    category: "Cabin Finishes",
    options: ["Mirror Finish SS", "Hairline SS", "Textured SS", "Golden Finish", "Rose Gold", "Bronze"]
  },
  {
    id: 2,
    category: "Flooring Options",
    options: ["Vitrified Tiles", "Granite", "Marble", "Anti-Skid Flooring", "Custom Patterns"]
  },
  {
    id: 3,
    category: "Ceiling Designs",
    options: ["LED Panel", "Laser Cut SS", "Backlit Panel", "Mirror Ceiling", "Custom Graphics"]
  },
  {
    id: 4,
    category: "Door Styles",
    options: ["Glass Panel", "Full Glass", "Stainless Steel", "Colored Glass", "Etched Glass"]
  }
];

export const services = [
  {
    id: 1,
    icon: "PenTool",
    title: "Design & Engineering",
    description: "Custom elevator designs tailored to your building's architecture and requirements."
  },
  {
    id: 2,
    icon: "Package",
    title: "Supply & Installation",
    description: "Complete supply chain management and professional installation services."
  },
  {
    id: 3,
    icon: "Settings",
    title: "Commissioning",
    description: "Thorough testing and commissioning to ensure optimal performance."
  },
  {
    id: 4,
    icon: "FileCheck",
    title: "Inspectorate Approval",
    description: "Complete documentation and support for Electrical Inspectorate approval."
  },
  {
    id: 5,
    icon: "Wrench",
    title: "AMC Services",
    description: "Comprehensive Annual Maintenance Contracts for worry-free operation."
  }
];

export const amcPlans = [
  {
    id: 1,
    name: "Normal Service",
    rate: "4%",
    description: "of contract value",
    features: ["Regular Maintenance", "Safety Inspections", "24/7 Emergency Support", "Periodic Servicing"]
  },
  {
    id: 2,
    name: "Comprehensive",
    rate: "7%",
    description: "of contract value",
    features: ["All Normal Services", "Spare Parts Included", "Priority Response", "Wear & Tear Coverage"],
    popular: true
  }
];

export const suppliers = [
  "Bharat Bijlee",
  "Genesys",
  "Sharp Engineers",
  "Fuji Electric",
  "Usha Martin",
  "Toshiba",
  "Weco",
  "Wittur",
  "Monarch",
  "ADCO",
  "Yaskawa"
];

export const stats = [
  { value: "30+", label: "Years Experience" },
  { value: "300+", label: "Installations" },
  { value: "100+", label: "AMC Contracts" },
  { value: "24/7", label: "Support" }
];

export const navLinks = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  { id: "products", label: "Products" },
  { id: "technology", label: "Technology" },
  { id: "customization", label: "Customization" },
  { id: "services", label: "Services" },
  { id: "contact", label: "Contact" }
];
